import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment/moment";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

const formatFilterDate = (value) => {
    if (!value) return ''
    const parsed = moment(value, ['DD/MM/YYYY', 'YYYY-MM-DD'], true)
    return parsed.isValid() ? parsed.format('YYYY-MM-DD') : value
}

export const constructionDailyLogList = createAsyncThunk('constructionDailyLogList', async ({ id, pageable: data, navigate }) => {

    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `construction-project/${id}/daily-log`,
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                ...(data?.log_date ? { log_date: formatFilterDate(data.log_date) } : {}),
                ...(data?.from_date ? { from_date: formatFilterDate(data.from_date) } : {}),
                ...(data?.to_date ? { to_date: formatFilterDate(data.to_date) } : {}),
                ...(data?.stage_id ? { stage_id: data.stage_id } : {}),
                ...(data?.work_status ? { work_status: data.work_status } : {}),
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": SessionManager.getCookie("user_token"),
            },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const constructionDailyLogListSlice = createSlice({
    name: 'constructionDailyLogList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(constructionDailyLogList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                const payloadData = action.payload.data.data;
                state.data = Array.isArray(payloadData) ? payloadData : payloadData?.rows ?? [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(constructionDailyLogList.rejected, (state) => {
            state.data = []
        })
    }
})

export default constructionDailyLogListSlice.reducer;
